import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configuracion-cuotas',
  templateUrl: './configuracion-cuotas.component.html',
  styleUrls: ['./configuracion-cuotas.component.scss']
})
export class ConfiguracionCuotasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
